import logoBrand from '@/assets/images/logo_basciano.svg'
import { Button } from '@/components/atoms/Button/Button'
// import { LanguageSelector } from '@/components/molecules/LanguageSelector/LanguageSelector'
import { Logo } from '@/components/molecules/Logo/Logo'
import { useModal } from '@/hooks/useModal'
import { motion } from 'framer-motion'
import { ChevronDown, Menu } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { MenuMobile } from '../MenuMobile/MenuMobile'
import { Modal } from '../Modal/Modal'
import { Select, SelectTrigger, SelectContent } from '@radix-ui/react-select'
import { ButtonContactUsModal } from '@/components/atoms/ButtonContactUsModal/ButtonContactUsModal'

interface HeaderProps {
  isError?: boolean
  isNotHome?: boolean
}

const Header: React.FC<HeaderProps> = ({ isError = false, isNotHome = false }) => {
  const { t } = useTranslation()
  const [isOpenModal, openModal, closeModal] = useModal(false)
  const navigate = useNavigate()

  // Función para manejar el scroll al hacer clic en los enlaces
  const handleScroll = (sectionId: string): void => {
    if (isError) {
      navigate('/')
    } else if (isNotHome) {
      navigate('/')
      setTimeout(() => {
        const section = document.getElementById(sectionId)
        if (section != null) {
          section.scrollIntoView({ behavior: 'smooth' })
        }
      }, 200)
    } else {
      // De lo contrario, desplázate a la sección correspondiente
      const section = document.getElementById(sectionId)
      if (section != null) {
        section.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  const goToPage = (url: string): void => {
    navigate(url)
  }

  return (
    <>
      <motion.header
        className='p-4 bg-white/90 z-10 fixed w-full shadow-md'
        initial={{ opacity: 0, y: -50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        <div className='w-full container lg:max-w-[1380px] mx-auto px-0 flex justify-between items-center'>
          <Link to='/'>
            <Logo src={logoBrand} alt='Basciano Trading Logo' width={255} height={71} />
          </Link>
          <div className='hidden lg:flex gap-2 items-center'>
            <nav className='flex items-center gap-4'>
              <ul className='flex items-center gap-4'>
                <li>
                  <button onClick={() => handleScroll('home')} className='text-primary hover:text-secondary font-bold'>
                    {t('header.home')}
                  </button>
                </li>
                <li>
                  <button onClick={() => handleScroll('aboutUs')} className='text-primary hover:text-secondary font-bold'>
                    {t('header.about')}
                  </button>
                </li>
                <li>
                  <Select>
                    <SelectTrigger className='w-[auto] bg-transparent border-none text-primary font-bold hover:text-secondary'>
                      <div className='flex items-center gap-1'>
                        {t('header.services')}
                        <ChevronDown size={14} />
                      </div>
                    </SelectTrigger>
                    <SelectContent className='shadow-md w-auto bg-white p-4 rounded-[10px] border-none cursor-pointer'>
                      <div className='min-w-[auto]'>
                        <div className='flex gap-2 items-center p-2'>
                          <button onClick={() => goToPage('/bussines')} className='text-primary border-none m-0 p-0'>
                            {t('header.bussines')}
                          </button>
                        </div>
                      </div>
                    </SelectContent>
                  </Select>
                </li>
                <li>
                  <button onClick={() => handleScroll('formContactUs')} className='text-primary hover:text-secondary font-bold'>
                    {t('header.contact')}
                  </button>
                </li>
              </ul>
            </nav>
          </div>
          <div className='gap-4 items-center hidden lg:flex'>
            <ButtonContactUsModal />
            <Button className='border border-primary text-primary hover:bg-primary font-semibold hover:text-white bg-transparent'>{t('header.login')}</Button>
          </div>
          <div className='flex lg:hidden' onClick={openModal}>
            <Menu size={24} />
          </div>
        </div>
      </motion.header>
      <Modal isOpenModal={isOpenModal} closeModal={closeModal}>
        <MenuMobile closeModal={closeModal} isNotHome={isNotHome} />
      </Modal>
    </>
  )
}

export default Header
